import AssignmentIcon from '@mui/icons-material/Assignment';
import {
  Box,
  Chip,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import React from 'react';
import ServiceProviderReceiverButtons from './ServiceProviderReceiverButtons.jsx';

const MessageRecipientForm = ({
  ticket,
  recipientType,
  email,
  errorOnEmailValidation,
  handleReceiverChange,
  addReceiver,
  subject,
  handleSubjectChange,
  receiverList,
  handleReceiverDelete,
  _handleReceiverClick,
  receiverMP,
  handleReceiverChangeFromMP,
  setReceiverList,
}) => {
  return (
    <>
      {ticket?.contactChannelType === 'RABBITMQ' &&
      recipientType === 'CONTACT' ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            flexDirection: 'column',
          }}
        >
          <FormControl>
            <FormLabel id="receiver-radio-buttons-group-label">
              Destinataire
            </FormLabel>
            <RadioGroup
              row
              aria-labelledby="receiver-radio-buttons-group-label"
              name="raw-receiver-radio-buttons-group"
              value={receiverMP}
              onChange={handleReceiverChangeFromMP}
            >
              <FormControlLabel
                value="customer"
                control={<Radio />}
                label="Client"
              />
              <FormControlLabel
                value="operator"
                control={<Radio />}
                label="Opérateur"
              />
            </RadioGroup>
          </FormControl>
          <Typography component={'span'} fontSize={12}>
            ⚠️ Les messages envoyés aux marketplaces ne peuvent pas contenir
            d&apos;image dans le corps du message.
          </Typography>
        </Box>
      ) : (
        <>
          <Grid
            container
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start',
            }}
          >
            <Grid sx={{ marginTop: 0 }}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-around',
                  gap: 1,
                }}
              >
                {recipientType === 'SERVICEPROVIDER' && (
                  <Grid size="grow">
                    <ServiceProviderReceiverButtons
                      setReceiverList={setReceiverList}
                    />
                  </Grid>
                )}
                <Grid size="grow">
                  <FormControl sx={{ minWidth: '100%' }}>
                    <TextField
                      error={
                        email?.length > 0 || errorOnEmailValidation !== null
                      }
                      helperText={
                        email?.length > 0 && errorOnEmailValidation === null
                          ? "Appuyer entrer pour valider l'adresse"
                          : errorOnEmailValidation
                      }
                      margin="dense"
                      id="receiver"
                      label="Destinataire"
                      value={email}
                      onChange={handleReceiverChange}
                      size="small"
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          addReceiver(email);
                        }
                      }}
                    />
                  </FormControl>
                </Grid>
                {ticket && (
                  <Grid size="grow">
                    <FormControl sx={{ minWidth: '100%' }}>
                      <TextField
                        margin="dense"
                        id="subject"
                        label="Sujet"
                        value={subject}
                        onChange={handleSubjectChange}
                        size="small"
                        slotProps={{
                          input: {
                            startAdornment: (
                              <Tooltip
                                title={`[${ticket?.reference}]${
                                  ticket?.order?.reference
                                    ? ` ${ticket?.order?.reference}`
                                    : ``
                                } `}
                              >
                                <InputAdornment position="start">
                                  <AssignmentIcon color="primary" />
                                </InputAdornment>
                              </Tooltip>
                            ),
                          },
                        }}
                      />
                    </FormControl>
                  </Grid>
                )}
              </Box>
            </Grid>
            <Divider sx={{ marginTop: 1, marginBottom: 1 }} />
            {receiverList?.length > 0 ? (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Box
                  sx={{
                    marginRight: 1,
                  }}
                >
                  <Typography component={'span'} fontSize={10}>
                    Destinataire :{' '}
                  </Typography>
                  <Chip
                    label={receiverList[0]}
                    onDelete={(_e) => handleReceiverDelete(receiverList[0])}
                  />
                </Box>
                <Box>
                  <Typography component={'span'} fontSize={10}>
                    CC :{' '}
                  </Typography>
                  {receiverList?.map((receiver, index) => {
                    if (index !== 0) {
                      return (
                        <Chip
                          key={index}
                          label={receiver}
                          onDelete={(_e) => handleReceiverDelete(receiver)}
                        />
                      );
                    }
                  })}
                </Box>
              </Box>
            ) : null}
          </Grid>
        </>
      )}
    </>
  );
};

export default MessageRecipientForm;
